import { gql } from '@apollo/client'

import { OrganizationFragment } from './organization.fragment'
import { UserFragment } from './user.fragment'
import { ProjectFragment } from './project.fragment'
import { CompanyFragment } from './company.fragment'

export const OrganizationRBACFragment = gql`
  fragment OrganizationRBACFragment on OrganizationUserRBAC {
    id
    createdDate
    updatedDate
    organization {
      ...OrganizationFragment
    }
    role
  }
  ${OrganizationFragment}
`

export const ProjectRBACFragment = gql`
  fragment ProjectRBACFragment on ProjectUserRBAC {
    id
    createdDate
    updatedDate
    user {
      ...UserFragment
    }
    project {
      ...ProjectFragment
    }
    company {
      ...CompanyFragment
    }
    role
    isActive
  }
  ${UserFragment}
  ${ProjectFragment}
  ${CompanyFragment}
`

export const ProjectFolderUserRBACFragment = gql`
  fragment ProjectFolderUserRBACFragment on ProjectFolderUserRBAC {
    id
    createdDate
    updatedDate
    projectFolderId
    userId
    role
  }
`
